import useSWR from "swr";
import axios from "axios";

function useAllocationReadyLabourers({ shouldFetch = true, projectId, startDate, endDate, page, perPage }) {
  return useSWR(shouldFetch ? [`${process.env.REACT_APP_API_URL}/labourers/allocation-ready`, projectId, startDate, endDate, page, perPage] : null, async ([url, projectId, startDate, endDate, page, perPage]) => {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (projectId) params.append('projectId', projectId);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const { data: { labourers, count } } = await axios.get(`${url}?${params.toString()}`);

    return { labourers, count };
  });
}

export default useAllocationReadyLabourers;
